export function formatBackupAge(value: number | null | undefined) {
  if (value === null || value === undefined) return '—'
  if (value < 3600) return `prije ${Math.max(1, Math.floor(value / 60))} min`
  if (value < 86_400) return `prije ${Math.floor(value / 3600)} h`
  return `prije ${Math.floor(value / 86_400)} d ${Math.floor((value % 86_400) / 3600)} h`
}
